import { Card } from "@/components/ui/card";
import { TESTIDS } from "@/constants/testIds";
import { getEngine } from "@/game/registry";

export function MoveExplanation({ state, rulesetId }) {
  const id = rulesetId || state?.rulesetId || "zimbabwe-standard";
  const engine = getEngine(id);
  const last = state.history?.[state.history.length - 1];
  const text = last
    ? engine.describeMove(last, state.sowingDirection)
    : "No moves yet. Tap a highlighted pit to play.";
  return (
    <Card data-testid={TESTIDS.moveExplanation} className="p-4">
      <p className="text-xs uppercase tracking-widest text-muted-foreground mb-1">
        Last move
      </p>
      <p className="text-sm leading-relaxed">{text}</p>
    </Card>
  );
}
